
import { defineComponent, onMounted } from "vue";
import { useI18n } from "vue-i18n/index";
import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import SampleCode from "@/components/manual/SampleCode.vue";
import ApiHeader from "@/components/manual/ApiHeader.vue";
import CallbackResponse from "@/components/manual/CallbackResponse.vue";
import LiveCallbackTester from "@/components/manual/LiveCallbackTester.vue";

export default defineComponent({
  name: "live-balance",
  components: {
    ApiHeader,
    LiveCallbackTester,
    CallbackResponse,
    SampleCode,
  },
  setup() {
    // vue variables
    const { t } = useI18n();
    // page variables
    const successResponse = {
      balance: 1000,
      member_id: "9fd4acc3-fa2c-4fc4-a530-fa517e8cdd6d",
    };
    const errorResponse = {
      message: "INVALID_MEMBER",
    };
    const errorComment = `
    /* INVALID_MEMBER = 회원 아이디 찾을 수 없는 경우
    ACCESS_DENIED = 헤더 맞지 않은 경우
    ERROR_OCCURED = 서버 오류 발생 경우 */\r`;

    const phpCode = `<?php

function balance($memberId) {

  $snowSec = getallheaders()['snowsec'];
  $agentCode = getallheaders()['agentcode'];
  $agentId = getallheaders()['agentid'];

  $data = json_decode(file_get_contents('php://input'), true);

  if($agentCode === AGENTCODE && $agentId === AGENTID && $snowSec === SNOWSEC) {
    try {
      $balance = 0;
      $response = array(
        'member_id' =>$data['member_id'],
        'balance' => $balance
      );
      print_r(json_encode($response));
    } catch(Exception $e) {
      header("HTTP/1.1 500 Internal Server Error");
      $response = ['message' => 'ERROR_OCCURED'];
      print_r(json_encode($response));
    }
  } else {
    header("HTTP/1.1 403 Forbidden");
    $response = ['message' => 'ACCESS_DENIED'];
    print_r(json_encode($response));
  }
?>
`;
    const aspCode = `<!--#include virtual="/jsonObject.class.asp" -->

<%

response.ContentType="application/json"

'Read JSON Request
bytecount = Request.TotalBytes
bytes = Request.BinaryRead(bytecount)
		
If bytecount = 0 Then

	Response.Status = "500 Internal Server Error"
	Response.write "{"
	Response.Write chr(34)&"message"&chr(34)&":"&chr(34)&"ERROR_OCCURED"&chr(34)
	response.write "}"

End If

SNOWSEC = Request.ServerVariables("HTTP_SNOWSEC")
AGENTCODE = Request.ServerVariables("HTTP_AGENTCODE")
AGENTID = Request.ServerVariables("HTTP_AGENTID")

If SNOWSEC = SNOWSEC And AGENTCODE = AGENTCODE And AGENTID = AGENTID Then

	Set stream = Server.CreateObject("ADODB.Stream")
		stream.Type = 1 'adTypeBinary              
		stream.Open()                                   
		stream.Write(bytes)
		stream.Position = 0                             
		stream.Type = 2 'adTypeText                
		stream.Charset = "utf-8"                      
		s = stream.ReadText() 'here is your json as a string                
		stream.Close()
	Set stream = nothing

	ls_object = s

	dim jsonObj, outputObj
		
	set jsonObj = new JSONobject
	set outputObj = jsonObj.parse(ls_object)

	member_id = outputObj("member_id")

	balance = BALANCE 'USER BALANCE

	Response.Status = "200 OK"
	Response.write "{"
	Response.Write chr(34)&"member_id"&chr(34)&":"&chr(34)&member_id&chr(34)
	Response.Write ","&chr(34)&"balance"&chr(34)&":"& balance
	response.write "}"

Else

	Response.Status = "403 Forbidden"
	Response.write "{"
	Response.Write chr(34)&"message"&chr(34)&":"&chr(34)&"ACCESS_DENIED"&chr(34)
	response.write "}"

End If

%>`;
    const aspNetCode = ``;

    onMounted(() => {
      MenuComponent.reinitialization();
      setCurrentPageBreadcrumbs(t("ApiManual.Balance"), [
        t("ApiManual.RealtimeCasino"),
      ]);
    });

    return {
      successResponse,
      errorResponse,
      errorComment,
      phpCode,
      aspCode,
      aspNetCode,
    };
  },
});
